import { useDispatch, useSelector } from "react-redux";
import { clearStoreCashOutDetail } from "../cashOut/store/thunk";
import { useEffect, useState } from "react";
import { PDFViewer } from "@react-pdf/renderer";
import { PDF } from "./PDF";

export const Modal = () => {

    const dispatch = useDispatch();
    const closeModal = () => {
        dispatch(clearStoreCashOutDetail());
        setMostrarPDF(false); // limpia si se cierra el modal
    }

    const { isLoading, cashOut_detail } = useSelector(state => state.cashOut);

    // console.log(cashOut_detail);
    

    let master = cashOut_detail?.master || [];
    let detalle = cashOut_detail?.detalle || [];
    let ordenes = cashOut_detail?.ordenes?.detalles || [];
    let ventas = cashOut_detail?.ventas?.detalles || [];
    let anticipos = cashOut_detail?.anticipos?.detalles || [];
    let descuentos = cashOut_detail?.descuentos || [];


    // console.log(descuentos);
    
    const [pdfKey, setPdfKey] = useState(0);
    const [mostrarPDF, setMostrarPDF] = useState(false);


    const generarPDF = () => {
        setMostrarPDF(false);
        setTimeout(() => {
            setPdfKey(prev => prev + 1);
            setMostrarPDF(true);
        }, 100);
    };


    useEffect(() => {
        if (cashOut_detail) {
            generarPDF();
        } else {
            setMostrarPDF(false);
        }
    }, [cashOut_detail]);

    return (
        <div className="modal fade" id="detailPDF" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-xl">
                <div className="modal-content">
                    <div className="modal-header">
                        <h1 className="modal-title fs-5 fw-bold" id="exampleModalLabel">Vista previa...</h1>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={closeModal}></button>
                    </div>

                    <div className="modal-body row pdfViewer">

                        {
                            (mostrarPDF) && (
                                <PDFViewer key={pdfKey} >
                                    <PDF masterArray={master} detalleRegistro={detalle} ordenesArray={ordenes} ventasArray={ventas} anticiposArray={anticipos} descuentosArray={descuentos} />
                                </PDFViewer>
                            )
                        }
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-outline-dark" data-bs-dismiss="modal" onClick={closeModal}>Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
    )
}
